<template>
  <div class="cmp-booking-artists-artist_list dt-page">
    <div class="dt-page--top-bar v1">
      <div class="dt-page--add-button">
        <div class="dt-icon-container">
          <img
            @click="onAddArtistClick"
            class="dt-icon v5 s1"
            src="static/buttons/add.svg"
            alt
          />
        </div>
      </div>
      <div class="search" style="max-width: 370px">
        <InputField
          :value="searchString"
          :placeholder="$t('search')"
          :config="{
            borderStyle: 'bottom',
            maxWidth: '200px',
            minWidth: '200px',
            width: '200px',
          }"
          @keyup="onSearchInputKeyup"
        ></InputField>
        <Dropdown
          style="margin-top: -1px; margin-left: 20px; min-width: 150px"
          :options="usersTV"
          :selected="selectedUser"
          :placeholder="$t('select_user')"
          deselect
          borderbottom
          v-on:selectedChange="(e) => onUserSelected(e)"
        ></Dropdown>
      </div>
      <div class="right-space"></div>
    </div>
    <div class="artist-list dt-page--data-table">
      <NTable
        id="booking-artists-artist_list"
        class="artist-list h1"
        :config="tableConfig"
        :headers="headers"
        :items="artists"
        :loadingFlag="loadingFlag"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr
            :class="{
              selected: selectedRow(item),
            }"
            @click="onRowClicked(item)"
          >
            <td v-bind="tdcon('artist_name')">
              <div>{{ item["artist_name"] }}</div>
            </td>
            <td v-bind="tdcon('performance_type')">
              <div>{{ item["performance_type"] }}</div>
            </td>
            <td v-bind="tdcon('main_contact')">
              <div>{{ item["main_contact"] }}</div>
            </td>
            <td v-bind="tdcon('city')">
              <div>{{ item["city"] }}</div>
            </td>
            <td v-bind="tdcon('phone1')">
              <div>{{ item["phone1"] }}</div>
            </td>
            <td v-bind="tdcon('phone2')">
              <div>{{ item["phone2"] }}</div>
            </td>
            <td v-bind="tdcon('options')">
              <div class="option-buttons">
                <div class="dt-icon-container">
                  <img
                    v-if="item['email1']"
                    src="static/icons/email/email-grey.svg"
                    class="dt-icon v5 s2"
                    @click="(e) => onMail(item)"
                    :alt="$t('mail_artist')"
                    :title="$t('mail_artist')"
                  />
                </div>
                <div class="dt-icon-container">
                  <img
                    src="static/icons/delete.svg"
                    @click.stop="(e) => deleteArtist(item)"
                    class="dt-icon v5 s2"
                    :alt="$t('delete_artist')"
                    :title="$t('delete_artist')"
                  />
                </div>
              </div>
            </td>
          </tr>
        </template>
      </NTable>
    </div>
    <!-- <v-navigation-drawer
        temporary
        :right="right"
        :clipped="clipped"
        :width=1200
        :value="artistDetailsFlag"
        fixed
        stateless
        hide-overlay
        app
      >
      <ArtistSideWindow
        @closeArtistSidewindow="onCloseArtistSidewindow"
      ></ArtistSideWindow>

      </v-navigation-drawer> -->

    <Sidewindow :value="artistDetailsFlag" @closed="onCloseArtistSidewindow">
      <ArtistSideWindow></ArtistSideWindow>
    </Sidewindow>
  </div>
</template>

<script>
import { BookingStoreNamespace as storeNS } from "../store";
import { mapActions, mapGetters, mapMutations } from "vuex";
import * as ArtistActionTypes from "../store/artists/types";
import InputField from "@plugins/text-field/input-field";
import Dropdown from "@plugins/dropdown/dropdown";

import Sidewindow from "../../../dt-plugins/sidewindow/sidewindow";
import ArtistSideWindow from "../components/artist/artist-sidewindow";

import {
  artistDetailsSelectable,
  SelectResults,
  artistDetailsRoute,
  artistListRoute,
  artistDetailsTabRoute,
} from "../router/router";
import { SET_MAIN_NAV_ACTIVE } from "../../../store/app/types";
import { childOfOrEqual } from "../../../router/functions";
import { decode } from "../../../utility";
import { Subject } from "rxjs";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";
import { ConfirmationService } from "../../../dt-plugins/confirmation/confirmation.service";
import { confirmDelete } from "@/dt-plugins/confirmation/confirmation-common";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../plugins/datatable";
import { bookingArtistListLDTRoutes, getBookingArtistDetailsSelectable } from "../router/routes";
import { async } from "ramda-adjunct";
import { createLDTHost } from "@/dt-plugins/sidewindow/LDTHost.mixin";

const LDTConfig = {
  entityName: "artist",
  ldtRoutes: bookingArtistListLDTRoutes,
  detailsSelectableFunction: getBookingArtistDetailsSelectable,
  primaryKey: "artist_id",
  storeNs: storeNS,
  SELECT_ACTION: ArtistActionTypes.ArtistDetails.FETCH.SINGLE,
  SELECT_AUTO_ACTION: ArtistActionTypes.ArtistDetails.FETCH.SINGLE,
  listKey : 'artists'
};

export default {
  components: {
    ArtistSideWindow,
    InputField,
    NTable,
    Sidewindow,
  },
  data: function () {
    return {
      right: true,
      clipped: false,
      selectedUser: null,

      searchString: "",
      searchSubject$: new Subject(),

      // tableConfig: createNTableConfig(),

      selectedClickedArtist: null,


      loadingFlag: false,
    };
  },
  mixins: [
    createLDTHost(LDTConfig),
  ],
  mounted: function () {
    this[ArtistActionTypes.ARTISTS.FETCH.ALL]();

    this.$subscribeTo(
      this.searchSubject$
        .asObservable()
        .pipe(distinctUntilChanged(), debounceTime(350)),
      (searchString) => {
        this[ArtistActionTypes.SEARCH_ARTIST](searchString);
      }
    );
  },
  watch: {
    $route: {
      immediate: true,
      handler: function (to, from) {
        // const { selectResult, artistId } = artistDetailsSelectable(to, from);
        // console.log('mdsir:artist:selectResult', selectResult, artistId);

        // switch (selectResult) {
        //   case SelectResults.SELECT: {
        //     this.selectArtist(artistId);
        //     break;
        //   }
        //   case SelectResults.SELECT_AUTO: {
        //     this.selectArtistAuto(artistId);
        //     break;
        //   }
        //   case SelectResults.CLOSE: {
        //     this.closeArtistDetails();
        //     break;
        //   }
        //   case SelectResults.IGNORE: {
        //     break;
        //   }
        // }

        // console.log("selectResult ...", selectResult, artistId);
      },
    },
  },
  computed: {
    ...mapGetters(storeNS, {
      artists: "artists",
      usersTV: "usersTV",
      // artistDetailsFlag: 'artistDetailsFlag',
    }),
    // artistDetailsFlag: function() {
    //   return childOfOrEqual(artistDetailsRoute)(this.$route.name);
    // },
    artistDetailsFlag: function () {
      return childOfOrEqual(bookingArtistListLDTRoutes.names.details)(
        this.$route.name
      );
    },
    tableConfig: function () {
      return createNTableConfig({
        fullHeight: true,
        rowHeight: 40,
      });
    },
    headers: function () {
      return [
        createTableHeader("rs_artist"),
        createTableHeader("performance"),
        createTableHeader("main_contact"),
        createTableHeader("city"),
        createTableHeader("phone1"),
        createTableHeader("phone2"),
        createTableHeader("options", {
          f: 0.5,
          mw: 100,
          text: false,
        }),
      ];
    },
  },
  methods: {
    ...mapActions(storeNS, {
      [ArtistActionTypes.ARTISTS.FETCH.ALL]:
        ArtistActionTypes.ARTISTS.FETCH.ALL,
      [ArtistActionTypes.SET_ARTIST_DETAILS]:
        ArtistActionTypes.SET_ARTIST_DETAILS,
      [ArtistActionTypes.SEARCH_ARTIST]: ArtistActionTypes.SEARCH_ARTIST,
      [ArtistActionTypes.FILTER_ARTIST_BY_USER]:
        ArtistActionTypes.FILTER_ARTIST_BY_USER,
      [ArtistActionTypes.DELETE_ARTIST]: ArtistActionTypes.DELETE_ARTIST,
    }),

    onRowClicked: function (artist) {
      console.log("selected Clicked Artist ", artist);
      this.selectedClickedArtist = artist;
      // this.$router.push({
      //   name: artist,
      //   params: {
      //     artist_id: artist.artist_id,
      //     tab: this.$route.params.tab
      //       ? this.$route.params.tab
      //       : "overview",
      //   },
      // });

      this.$router.push({
        name: bookingArtistListLDTRoutes.names.tab,
        params: {
          artist_id: artist.artist_id,
          tab: this.$route.params.tab ? this.$route.params.tab : "overview",
        },
      });
    },
    onMail: function (artist) {},
    deleteArtist: async function (artist) {
      const confirmationResult = await confirmDelete(
        "Artist",
        artist.artist_name
      );
      if (confirmationResult === "OK") {
        this[ArtistActionTypes.DELETE_ARTIST]({
          artistId: artist.artist_id,
        });
      }
      // console.log("artistartist",artist)
      // ConfirmationService.create({
      //   subject: `Do you really want to delete the artist "${
      //     artist.artist_name
      //   }" ?`,
      //   model: true,
      //   width: 500,
      //   completed: res => {
      //     switch (res) {
      //       case "OK": {
      //         this[ArtistActionTypes.DELETE_ARTIST]({
      //           artistId: artist.artist_id
      //         });
      //         break;
      //       }
      //     }
      //   }
      // });
    },
    onCloseArtistSidewindow: function () {
      this.selectedClickedArtist = null;
      this.closeArtistDetails();
      if (this.$route.query && this.$route.query.from) {
        this.$router.push({
          ...decode(this.$route.query.from),
        });
      } else {
        this.$router.push({
          name: bookingArtistListLDTRoutes.names.list,
        });
      }
    },
    selectArtist: function (artistId) {
      console.log("selectArtist ... ", artistId);
      const selectedArtist = this.artists.find(
        (artist) => artist.artist_id === artistId
      );
      console.log("selectedArtist ... ", {
        flag: true,
        artist: selectedArtist,
      });
      this[ArtistActionTypes.SET_ARTIST_DETAILS]({
        flag: true,
        artist: selectedArtist,
        artist_id: artistId
      });
    },
    selectArtistAuto: function (artist_id) {
      console.log("selectArtistAuto ... ", artist_id);
      console.log("select Artist Auto ... ", {
        flag: true,
        artist: { artist_id },
      });
      this[ArtistActionTypes.SET_ARTIST_DETAILS]({
        flag: true,
        artist: { artist_id },
        // artist: { artistId }
      });
    },
    closeArtistDetails: function () {
      this[ArtistActionTypes.SET_ARTIST_DETAILS]({
        flag: false,
      });
    },
    onSearchInputKeyup: function (event) {
      this.selectedUser = null;
      this.searchString = event.target.value;
      console.log("Searchstring Set", this.searchString);
      // console.timeEnd('Keystroke');
      // console.time('Keystroke');
      // console.time('SearchstringNext');
      this.searchSubject$.next(this.searchString);
    },
    onUserSelected: function (value) {
      this.searchString = "";
      this.selectedUser = value;

      this[ArtistActionTypes.FILTER_ARTIST_BY_USER]({
        userId: this.selectedUser && this.selectedUser.value,
      });
    },
    onAddArtistClick: function () {
      console.log("onAddArtistClick");
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_artist",
        },
      });
    },
    selectedRow: function (artist) {
      return (
        this.selectedClickedArtist &&
        this.selectedClickedArtist["artist_id"] === artist["artist_id"]
      );
    },
    
    async fetchList() {
      this.loadingFlag = true;
      await this[ArtistActionTypes.ARTISTS.FETCH.ALL]();
      this.loadingFlag = false;
    }
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.dt-page--data-table {
  // --offset: 125px;
}

.cmp-booking-artists-artist_list {
  .dt-ntable.artist-list {
    --ntable-height: calc(100vh - 120px) !important;

    td.artist_name {
      font-weight: 800 !important;
    }
    td.options {
      .option-buttons {
        display: flex;
        justify-content: space-between;
      }
    }

    /* th:nth-child(7),
      td:nth-child(7) {
        flex: 0.5;
      } */
  }
  .artist-top-bar {
    margin-bottom: 10px;
    display: flex;
    flex-direction: row;

    & > div {
      margin: 0px 10px;
    }

    // .normal-filters {
    //   flex: 1;
    //   display: flex;
    //   margin-left: 15px;
    //   margin-bottom: 10px;
    //   color: var(--text-primary);
    //   flex-wrap: wrap;
    // }
    .users-dropdown {
      flex: 3;
    }
    .right-space {
      flex: 5;
    }

    .dropdown {
      flex: 5;
      max-width: 127px;
      margin: 0px 10px;

      // /deep/ .dropdown--main {
      //   border-bottom: 1px solid var(--sprt-5);
      // }
    }
  }
}
</style>
